import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-title">
          <img 
            src="/ARU-2025.png" 
            alt="ARU Logo" 
            className="header-logo"
          />
          <button
            onClick={() => {
              const currentPath = window.location.pathname;
              if (currentPath.includes('rise')) {
                navigate('/rise');
              } else if (currentPath.includes('surefyre')) {
                navigate('/surefyre');
              } else {
                navigate('/surefyre');
              }
            }}
            className="home-button"
            title="Home"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22V12H15V22"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 className="header-app-title">Quick Refer App</h1>
        </div>
        <div className="header-actions">
          <a
            href="https://docs.google.com/document/d/1_DdD3NwgnlZglwxdDnT-LZ2ZDt-7U0Qne3gTXTSICfo/edit?tab=t.0"
            target="_blank"
            rel="noreferrer"
            className="help-link"
          >
            HELP
          </a>
        </div>
        <div className="user-info">
          {user.picture && (
            <img 
              src={user.picture} 
              alt={user.name} 
              className="user-avatar"
            />
          )}
          <div className="user-details">
            <span className="user-name">{user.name}</span>
            <span className="user-email">{user.email}</span>
          </div>
          <button onClick={logout} className="logout-button">
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;